import { Group, Paper, Stack, Tooltip, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import classes from '../Home/Home.module.css'
import '@mantine/charts/styles.css';
import { BarChart } from '@mantine/charts';



const TableWithLoaderReportesRDI = ({ heigth, allData, headers }) => {
    function safeUrl(input) {
        try {
            const url = new URL(input);
            if (url.protocol !== "https:" && url.protocol !== "http:") {
                throw new Error("Invalid protocol");
            }
            return url.toString();
        } catch {

            return null;
        }
    }
    const DescargaFunction = () => {
        fetch(process.env.REACT_APP_API_ENP + "/sscn-back/api/utils/getS3LinkReporteCSVRDI",
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error while getting S3 link! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {

                const s3Url = data?.link;
                if (!s3Url) throw new Error("S3 URL not found in response");
                showNotification({
                    title: 'Listo!',
                    message: 'Iniciando descarga del archivo',
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#25A661',
                            borderColor: '#25A661',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: true,
                });
                const validatedUrl = safeUrl(s3Url);
                if (!validatedUrl) return;

                const link = document.createElement("a");
                link.href = encodeURI(validatedUrl);

                link.download = "alertas.csv"; // or .csv, .txt, etc.

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => {
                showNotification({
                    title: 'Error!',
                    message: err.response?.data?.error ? err.response.data.error : err.message,
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#E93F19',
                            borderColor: 'E93F19',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                })
            });
    }

    return (
        <>
            <div style={{ gridColumn: '1 / -1' }}>
                <Stack spacing="md" align="flex-end">
                    <Paper height={2} shadow="lg" radius="lg" withBorder p={0}>
                        <Group justify="center" gap={0}>
                            <Tooltip label="Descarga" position="right" transitionProps={{ duration: 0 }}>
                                <UnstyledButton onClick={DescargaFunction} className={classes.link}>
                                    <FontAwesomeIcon icon={faDownload} size="lg" />
                                </UnstyledButton>
                            </Tooltip>
                        </Group>
                    </Paper>
                </Stack>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
                <Stack spacing="md">
                    <Paper shadow="xl" radius="xl" withBorder p="xl">
                        <BarChart
                            h={300}
                            data={allData}
                            dataKey="label"
                            series={
                                [
                                    { name: 'Totales', color: 'teal.6' },
                                ]}
                        />
                    </Paper>
                </Stack>
            </div>
        </>
    );
};

export default TableWithLoaderReportesRDI;